export default __webpack_public_path__ + "static/media/app_development_SVG.5374a95f.svg";